<template>
  <div
    class="position-relative w-80"
    style="transform: translateX(25%);"
  >
    <feather-icon
      v-if="showScrollButtons && technicalReg.length > 4"
      icon="ArrowLeftCircleIcon"
      class="scroll-btn left-btn"
      size="30"
      @click="scrollLeft"
    />

    <!-- Nav Bar -->
    <div
      ref="scrollContainer"
      class="nav-scroll-container"
      :style="technicalReg.length > 4 ? 'display: block' : 'display: flex; justify-content: end;'"
    >
      <b-nav
        pills
        class="d-flex flex-nowrap"
      >
        <b-nav-item
          v-for="(item, index) in technicalReg"
          :key="index"
          :active="item.active"
          @click="setActiveTab(item.id)"
        >
          {{ item.name }}
        </b-nav-item>
      </b-nav>
    </div>

    <feather-icon
      v-if="showScrollButtons && technicalReg.length > 4"
      icon="ArrowRightCircleIcon"
      class="scroll-btn right-btn"
      size="30"
      @click="scrollRight"
    />
  </div>
</template>

<script>
export default {
  props: {
    technicalReg: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showScrollButtons: false,
    }
  },
  mounted() {
    this.checkScroll()
    window.addEventListener('resize', this.checkScroll)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScroll)
  },
  methods: {
    setActiveTab(id) {
      this.$emit('tab-selected', id)
    },
    scrollLeft() {
      this.$refs.scrollContainer.scrollLeft -= 100
    },
    scrollRight() {
      this.$refs.scrollContainer.scrollLeft += 100
    },
    checkScroll() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer
        if (container.scrollWidth > 800) {
          this.showScrollButtons = true
        } else {
          this.showScrollButtons = false
        }
      })
    },
  },
}
</script>

<style scoped>
.w-80{
  max-width: 70vw;
}
.nav-scroll-container {
  position: relative;
  overflow-x: auto;
  scroll-behavior: smooth;
  white-space: nowrap;
  -ms-overflow-style: none;
  padding: 0rem 2.5rem;
}
.nav-scroll-container::-webkit-scrollbar {
  display: none;
}
.scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-60%) ;
  z-index: 10;
  background-color: white;
  cursor: pointer;
  height: 100%;
}
.scroll-btn:hover {
  color: #40aaf7;
}
.left-btn {
  left: 0;
}
.right-btn {
  right: 0;
}
</style>
